import React, { useState, useEffect } from "react";
import { axiosInstance } from "store/auth";
import Modal from "components/Modal";
import {
  ArrowLeft,
  Folder,
  PlayCircle,
  Check,
  Loader,
  ChevronRight,
} from "lucide-react";
import { ChevronLeft } from "react-feather";

const VideoSelector = ({ show, close, title, initialVideo, setVideo }) => {
  const [slug, setSlug] = useState("");
  const [folders, setFolders] = useState([]);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(initialVideo || null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData(""); // Load root folder initially
  }, []);

  const fetchData = async (folderSlug) => {
    setLoading(true);
    try {
      const response = await axiosInstance?.post("/video-player/", {
        slug: folderSlug,
      });
      setFolders(response?.data?.data?.folder);
      setVideos(response?.data?.data?.videos);
      setSlug(folderSlug);
    } catch (error) {
      console?.error("Error fetching data", error);
    }
    setLoading(false);
  };

  const handleFolderClick = (folderSlug) => {
    fetchData(folderSlug);
  };

  const handleBreadcrumbClick = (index) => {
    const parts = slug.split("-");
    const newSlug = parts.slice(0, index + 1).join("-");
    fetchData(newSlug);
  };

  const breadcrumbItems = slug
    ? slug.split("-").map((part, index, array) => ({
        title: part,
        slug: array.slice(0, index + 1).join("-"),
      }))
    : [];

  const handleVideoSelect = (video) => {
    setSelectedVideo(video);
    setVideo(video);

    close();
  };

  const filteredFolders = folders.filter((folder) =>
    folder?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredVideos = videos.filter((video) =>
    video?.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Modal
      show={show}
      handleClose={close}
      title={title}
      className="z-[99999999999999] fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div className="p-4 ">
        <div className="flex justify-between items-center mb-4">
          {slug && (
            <button
              onClick={() => handleBreadcrumbClick(breadcrumbItems.length - 2)}
              className="text-blue-600 hover:text-blue-800"
            >
              <ArrowLeft size={20} />
            </button>
          )}
          <button
            onClick={close}
            className="text-green-600 hover:text-green-800"
          >
            <Check size={20} />
          </button>
        </div>

        {/* Breadcrumb Navigation */}
        <div className="flex items-center text-sm text-gray-700 mb-3">
          <button
            onClick={() => fetchData("")}
            className="hover:text-blue-600 font-semibold"
          >
            ریشه
          </button>
          {breadcrumbItems.map((item, index) => (
            <React.Fragment key={index}>
              <ChevronLeft size={16} className="mx-1 text-gray-500" />
              <button
                onClick={() => handleBreadcrumbClick(index)}
                className={`hover:text-blue-600 ${
                  index === breadcrumbItems.length - 1 ? "font-semibold" : ""
                }`}
              >
                {item.title}
              </button>
            </React.Fragment>
          ))}
        </div>

        {selectedVideo && (
          <div className="mb-3 p-3 bg-green-100 border border-green-400 rounded-lg shadow-sm">
            <p className="text-green-700 font-semibold flex items-center gap-2 text-[13px]">
              {selectedVideo?.title}
            </p>
          </div>
        )}

        <input
          type="text"
          placeholder="جستجوی پوشه و ویدیو..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-2 border rounded-md mb-3"
        />

        {loading && (
          <div className="flex justify-center my-4">
            <Loader className="animate-spin text-blue-500" size={24} />
          </div>
        )}

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {filteredFolders.map((folder) => (
            <button
              key={folder?.slug}
              onClick={() => handleFolderClick(folder?.fullSlug)}
              className="flex items-center justify-start p-3 rounded-md bg-blue-100 hover:bg-blue-200"
              disabled={loading}
            >
              <Folder className="mr-2 ml-2" /> {folder?.title}
            </button>
          ))}
        </div>

        <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mt-3">
          {filteredVideos.map((video) => (
            <li
              key={video?.videoId}
              onClick={() => handleVideoSelect(video)}
              className="p-3 flex items-center justify-between bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
            >
              <span className="flex items-center">
                <PlayCircle className="mr-2 ml-2 text-blue-600" />
                {video?.title}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export default VideoSelector;
